import { STORAGE_KEYS } from "../const";

function isLoggedIn() {
  const terminalAuthToken = localStorage.getItem(STORAGE_KEYS.TERMINAL_AUTH_TOKEN);
  if (terminalAuthToken) {
    return true;
  }

  const userAuthToken = localStorage.getItem(STORAGE_KEYS.USER_AUTH_TOKEN);
  if (userAuthToken) {
    return true;
  }

  return false;
}

const UserHelper = {
  isLoggedIn,
};

export default UserHelper;
